import React, { useState } from 'react';
import { BiSolidPhoneCall } from "react-icons/bi";
import '../Servicemain/Servicesmain.css';

const callAdmin = () => {
  window.location.href = 'tel: +919220347091'; 
};

const servicesData = [
  {
    id: 1,
    image: '/lc.jpeg',
    title: 'Live Concerts',
    description: 'Experience the thrill of live music at its finest. Whether it\'s a large festival or an intimate performance, we bring the best musicians and production to make your event unforgettable.',
  },
  {
    id: 2,
    image: '/coe.jpg',
    title: 'Corporate Events',
    description: 'Host impactful corporate seminars with flawless organization. From engaging presentations to seamless logistics, we ensure that your business seminars are professional and effective.',
  },
  {
    id: 3,
    image: '/we.png',
    title: 'Wedding Events',
    description: 'Make your wedding day magical with expert planning and execution. From beautiful decor to impeccable service, we ensure every detail is perfect for your special day.',
  },
  {
    id: 4,
    image: '/se.png',
    title: 'Social Events',
    description: 'Bring people together for an unforgettable social experience. Whether it\'s a party, a reunion, or a celebration, we offer unique themes, exciting activities, and delicious catering to make your event stand out.',
  },
];

const Services = () => {
  const [visibleCards, setVisibleCards] = useState(2);

  const handleToggle = () => {
    setVisibleCards(prev => prev === 2 ? servicesData.length : 2);
  };

  return (
    <div className="services-section">
      <div className="video-header">
        <video 
          autoPlay 
          muted 
          loop 
          className="video-background" 
          preload="none"
        >
          <source src="/services.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay"></div>
        <div className="video-content">
          <p className="section-subtitle">श्री Var Event & Conference Services</p>
          <h1 className="section-title">Bringing Your Dream Event to Life</h1>
          <div className="divider"></div>
        </div>
      </div>

      <div className="services-container">
        {servicesData.slice(0, visibleCards).map((service, index) => (
          <div 
            key={service.id} 
            className={`service-card ${index % 2 === 0 ? 'left-image' : 'right-image'}`}
          >
            <div className="card-images">
              <img 
                src={service.image} 
                alt={service.title} 
                loading="lazy" 
              />
            </div>
            <div className="card-content">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <button className="card-button" onClick={callAdmin}>
                Contact <BiSolidPhoneCall className="button-icon" />
              </button>
            </div>
          </div>
        ))}
      </div>

      {servicesData.length > 2 && (
        <button onClick={handleToggle} className="toggle-button">
          {visibleCards === 2 ? 'View All Services' : 'Show Less'}
        </button>
      )}
    </div>
  );
};

export default Services;
